import { useEffect } from "react";
import { CONTACT } from "../data/content";

const SITE_URL = (typeof window !== "undefined" && window.location.origin) || "https://innpact.com.pt";

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": ["HairSalon", "LocalBusiness", "BeautySalon"],
  "@id": `${SITE_URL}/#business`,
  name: "INN.PACT — Clínica de Imagem",
  alternateName: "INN.PACT",
  description:
    "Clínica de imagem em Leiria: consultoria de imagem, hairstyling, visagismo, pack noivas, man style e workshops. Aconselhamento personalizado e gratuito.",
  url: SITE_URL,
  logo: `${SITE_URL}/images/logo.png`,
  image: [
    `${SITE_URL}/images/hero.webp`,
    `${SITE_URL}/espaco/espaco_entrada.webp`,
    `${SITE_URL}/espaco/espaco_salao.webp`,
  ],
  telephone: `+351 ${CONTACT.mobile}`,
  email: CONTACT.email,
  priceRange: "€€",
  currenciesAccepted: "EUR",
  paymentAccepted: "Cash, Credit Card, MB WAY",
  address: {
    "@type": "PostalAddress",
    streetAddress: CONTACT.address,
    addressLocality: "Leiria",
    addressRegion: "Leiria",
    postalCode: "2400-000",
    addressCountry: "PT",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 39.7495,
    longitude: -8.8074,
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      opens: "09:00",
      closes: "13:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      opens: "14:30",
      closes: "20:00",
    },
  ],
  sameAs: [CONTACT.facebook, CONTACT.instagram],
  founder: {
    "@type": "Person",
    name: "Severina Gomes",
    jobTitle: "Founder, CEO & Style Coach",
  },
  areaServed: {
    "@type": "City",
    name: "Leiria",
  },
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Serviços INN.PACT",
    itemListElement: [
      {
        "@type": "Offer",
        itemOffered: { "@type": "Service", name: "Hairstyling", description: "Aconselhamento personalizado e gratuito. Análise de rosto e biótipo." },
      },
      {
        "@type": "Offer",
        itemOffered: { "@type": "Service", name: "Pack Noivas", description: "Identidade visual coerente para o dia do casamento." },
      },
      {
        "@type": "Offer",
        itemOffered: { "@type": "Service", name: "Consultoria de Imagem", description: "Consultoria pessoal, empresarial e para lojas." },
      },
      {
        "@type": "Offer",
        itemOffered: { "@type": "Service", name: "Man Style", description: "Consultoria de imagem masculina, prática e direta." },
      },
      {
        "@type": "Offer",
        itemOffered: { "@type": "Service", name: "Workshops & Formação", description: "Formação em tendências e cuidados de imagem." },
      },
    ],
  },
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: "INN.PACT — Clínica de Imagem",
  inLanguage: "pt-PT",
  publisher: { "@id": `${SITE_URL}/#business` },
};

const injectSchema = (id, schema) => {
  let node = document.getElementById(id);
  if (!node) {
    node = document.createElement("script");
    node.type = "application/ld+json";
    node.id = id;
    document.head.appendChild(node);
  }
  node.textContent = JSON.stringify(schema);
};

export const SEO = ({ pageSchema = null } = {}) => {
  useEffect(() => {
    injectSchema("ld-business", localBusinessSchema);
    injectSchema("ld-website", websiteSchema);
    if (pageSchema) {
      injectSchema("ld-page", pageSchema);
    } else {
      const n = document.getElementById("ld-page");
      if (n) n.remove();
    }
  }, [pageSchema]);
  return null;
};

export default SEO;
